import { render, staticRenderFns } from "./customerinfo.vue?vue&type=template&id=135a9ece"
import script from "./customerinfo.vue?vue&type=script&lang=js"
export * from "./customerinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports